import { DirectionsCar, Group } from '@mui/icons-material'
import { Typography } from '@mui/material'
import Grid from '@mui/material/Unstable_Grid2/Grid2'
import CardPessoa from '../CardPessoa/CardPessoa'
import { useContext } from 'react'
import { VisitantesContext } from '../../../../Providers/VisitantesContext/VisitantesContext'

const PessoasImovelCard = () => {
    const { moradores, imovelSelecionado } = useContext(VisitantesContext)
    return (
        <Grid sx={{
            display: 'flex',
            flexDirection: 'column',
            borderRight: '1px solid white',
            width: '80%',
            height: '100%',
            padding: '3px'
        }}>
            <Grid sx={{
                display: 'flex',
                flexDirection: 'row',
                width: '100%',
                height: '10%',
                alignItems: 'center'
            }}>
                <Grid sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    width: '50%',
                    alignItems: 'center'
                }}>
                    <Group sx={TypographySx}/>
                    <Typography sx={{ ...TypographySx, marginLeft: '5px' }}>
                        Pessoas do Imóvel:
                    </Typography>
                </Grid>
                <Grid sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    width: '50%',
                    alignItems: 'center'
                }}>
                    <DirectionsCar sx={TypographySx}/>
                    <Typography sx={{ ...TypographySx, marginLeft: '5px' }}>
                        Vagas disponíveis no Imóvel:  {imovelSelecionado && imovelSelecionado.vagas_disponiveis ? imovelSelecionado.vagas_disponiveis : 0}
                    </Typography>
                </Grid>
            </Grid>
            <Grid sx={{
                display: 'flex',
                flexDirection: 'row',
                width: '100%',
                height: '90%',
                flexWrap: 'wrap',
                overflowY: 'scroll',
                justifyContent: 'space-around'
            }}>
                {moradores && moradores.length > 0
                    ? (moradores.map((pessoa, index) => {
                        return <CardPessoa pessoa={pessoa} ramalImovel={imovelSelecionado.ramal} tipo_licenca_cond={imovelSelecionado.tipo_licenca_cond} key={index}/>
                    })
                    )
                    : (
                        <Typography sx={TypographySx}>
                    Nenhuma pessoa cadastrada para esse imóvel!
                        </Typography>
                    )
                }

            </Grid>
        </Grid>
    )
}

export default PessoasImovelCard

const TypographySx = {
    color: 'black',
    fontWeight: 600,
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '14px'
}
